// extracted by mini-css-extract-plugin
export default {"innerWrapper":"GA-z","tooltipWrapper":"HA-z","icon":"IA-z","tooltip":"JA-z","content":"KA-z"};